<template>
  <div :class="[baseCss]">
    <div v-if="label" v-html="setLabel" :style="{lineHeight: `${size}px`, color: labelColor}" :class="[`text-${labelSize}`, 'bcq-gauge-label', 'font-semibold', 'absolute', 'w-full', 'text-center']" />
    <svg :width="size" :height="size" :viewPort="`0 0 ${size / 2} ${size / 2}`" xmlns="http://www.w3.org/2000/svg">
      <circle :style="{strokeWidth: `${width}em`, stroke: trackColor}" :class="['track']" :r="radius" :cx="size / 2" :cy="size / 2" fill="transparent" :stroke-dasharray="getRadius" stroke-dashoffset="0" />
      <circle :style="{strokeWidth: `${width}em`, stroke: progressColor}" :class="['bar']" :stroke-linecap="rounded ? 'round' : 'butt'" :r="radius" :cx="size / 2" :cy="size / 2" fill="transparent" :stroke-dasharray="getRadius" stroke-dashoffset="0" />
    </svg>
  </div>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'Gauge',
  mixins: [
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('gauge', ['inline-block', 'select-none', 'align-middle', 'relative'])
    }
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: [Number, String]
    },
    radius: {
      type: Number,
      default: 64
    },
    label: {
      type: Boolean,
      default: true
    },
    size: {
      type: Number,
      default: 200
    },
    rounded: {
      type: Boolean,
      default: true
    },
    width: {
      type: Number,
      default: 1
    },
    trackColor: {
      type: String,
      default: '#cccccc'
    },
    progressColor: {
      type: String,
      default: '#333333'
    },
    labelSize: {
      type: String,
      default: 'xl',
      validator: value => {
        return ['xs', 'md', 'sm', 'base', 'lg', 'xl', '2xl', '3xl', '4xl', '5xl', '6xl', '7xl', '8xl', '9xl'].includes(value)
      }
    },
    labelColor: {
      type: String,
      default: '#000'
    }
  },
  computed: {
    getRadius () {
      return Math.PI * (this.radius * 2)
    },
    setLabel () {
      return `${this.value}%`
    }
  },
  watch: {
    value () {
      this.paint()
    }
  },
  mounted () {
    this.paint()
  },
  methods: {
    paint () {
      let value = parseInt(this.value, 10)
      let circle = this.$el.querySelector('.bar')
      if (isNaN(value)) {
        value = 100
      } else {
        if (value < 0) {
          value = 0
        }
        if (value > 100) {
          value = 100
        }
        const percentage = ((100 - value) / 100) * this.getRadius
        circle.style.strokeDashoffset = percentage
        this.$emit('input', this.value)
      }
    }
  }
}
</script>
<style>
.bcq-gauge circle
{
  stroke-dashoffset: 0;
  transition: stroke-dashoffset .5s ease-in-out;
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/gauge/gauge.vue